<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <form [formGroup]="ServiceRequestForm" (ngSubmit)="UpdateSR()">
                        <div class="card-header card-header-danger">
                            <div class="row">
                                <div class="col-md-6">

                                    <h4>Service Request - {{ServiceRequestForm.get('SRNumber').value}}</h4>
                                </div>
                                <div class="col-md-6" style="text-align: right;">
                                    <i class="fa fa-paperclip" style="font-size:14px; cursor: pointer"
                                        (click)="Attachment.click()">
                                        <button type="button" #Attachment style="display:none;"
                                            (click)="openFileUploadDialog()"></button>

                                    </i>

                                    &nbsp;&nbsp;
                                    <i class="fa fa-envelope" style="font-size:14px; cursor: pointer"
                                        *ngIf="IsButtonHide" (click)="mail.click()">

                                        <button type="button" #mail style="display:none;"
                                            (click)="openMailTemplateDialog()"></button>
                                    </i> &nbsp;&nbsp;

                                    <button type="Submit" class="btn-primary1" *ngIf="IsButtonHide">Update</button>
                                    <button type="button" class="btn-primary1"
                                        (click)="_commonService.Exit()">Exit</button>
                                </div>
                            </div>


                        </div>
                        <div class="clearfix"></div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel">
                                            <label><span>Number</span></label></div>
                                        <div class="col-md-8"> <input class="form-control" readonly="true"
                                                formControlName="SRNumber"></div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label>Status</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p-dropdown [options]="statusList" placeholder="--Select--"
                                                formControlName="StatusID" filter="true" [showClear]="true"
                                                (onChange)="GetStatusName($event)">
                                            </p-dropdown>
                                            <mat-error
                                                *ngIf="GetFormControls('StatusID').invalid && (GetFormControls('StatusID').dirty || GetFormControls('StatusID').touched)"
                                                class="ValidationError">
                                                <mat-error *ngIf="GetFormControls('StatusID').errors.required">
                                                    Status is required.
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label
                                                class="control-label">Requester</label></div>
                                        <div class="col-md-8">
                                            <input class="form-control" formControlName="RequestedBy" [readonly]="true">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel">
                                            <label>Priority</label></div>
                                        <div class="col-md-8">
                                            <p-dropdown [options]="priorityList" placeholder="--Select--"
                                                formControlName="PriorityID" filter="true" [showClear]="true"
                                                (onChange)="GetpriorityName($event)">
                                            </p-dropdown>
                                            <!-- <mat-error
                                              *ngIf="GetFormControls('Priority').invalid && (GetFormControls('Priority').dirty || GetFormControls('Priority').touched)"
                                              class="ValidationError">
                                              <mat-error *ngIf="GetFormControls('Priority').errors.required">
                                              Priority is required.
                                              </mat-error>
                                            </mat-error> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label
                                                class="control-label">Requester GPN</label></div>
                                        <div class="col-md-8"> <input class="form-control" [readonly]="true"
                                                formControlName="RequestedByGPN"></div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel">
                                            <label>Category</label></div>
                                        <div class="col-md-8">
                                            <p-dropdown [options]="categoryList" placeholder="--Select--"
                                                formControlName="CategoryId" filter="true"
                                                (onChange)="GetSubCategoryName($event)" [showClear]="true">
                                            </p-dropdown>
                                            <mat-error
                                                *ngIf="GetFormControls('CategoryId').invalid && (GetFormControls('CategoryId').dirty || GetFormControls('CategoryId').touched)"
                                                class="ValidationError">
                                                <mat-error *ngIf="GetFormControls('CategoryId').errors.required">
                                                    Category is required.
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label
                                                class="control-label">Requester Phone</label></div>
                                        <div class="col-md-8"> <input class="form-control" [readonly]="true"
                                                formControlName="RequestedByCUG"></div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label>Sub
                                                Category</label></div>
                                        <div class="col-md-8">
                                            <p-dropdown [options]="subcategoryList" placeholder="--Select--"
                                                formControlName="SubCategoryId" filter="true"
                                                (onChange)="BindItemName($event)" [showClear]="true">
                                            </p-dropdown>
                                            <mat-error
                                                *ngIf="GetFormControls('SubCategoryId').invalid && (GetFormControls('SubCategoryId').dirty || GetFormControls('SubCategoryId').touched)"
                                                class="ValidationError">
                                                <mat-error *ngIf="GetFormControls('SubCategoryId').errors.required">
                                                    Sub Category is required.
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label
                                                class="control-label">Requested For other</label></div>
                                        <div class="col-md-8">
                                            <mat-checkbox class="example-margin" formControlName="IsRequestedFor"
                                                disabled [checked]="ServiceRequestForm.controls.IsRequestedFor.value">
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label>Item</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p-dropdown [options]="itemList" placeholder="--Select--"
                                                formControlName="ItemId" filter="true" [showClear]="true"
                                                (onChange)="BindAssigmentGroup($event,1)">
                                            </p-dropdown>
                                            <mat-error
                                                *ngIf="GetFormControls('ItemId').invalid && (GetFormControls('ItemId').dirty || GetFormControls('ItemId').touched)"
                                                class="ValidationError">
                                                <mat-error *ngIf="GetFormControls('ItemId').errors.required">
                                                    Item is required.
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label
                                                class="control-label">Requested For</label></div>
                                        <div class="col-md-8">
                                            <p-autoComplete formControlName="RequestedforHead"
                                                [suggestions]="requesterList"
                                                (completeMethod)="SearchAllActiveEmployee($event)" field="EmployeeName"
                                                [forceSelection]="true" [minLength]="3" size="120"
                                                (onSelect)="SetRequesterforDetails($event)"
                                                (onClear)="clearAutoComplete('RequesterForHead')" readonly="true">
                                            </p-autoComplete>
                                            <mat-error
                                                *ngIf="GetFormControls('RequestedforHead').invalid && (GetFormControls('RequestedforHead').dirty || GetFormControls('RequestedforHead').touched)"
                                                class="ValidationError">
                                                <mat-error *ngIf="GetFormControls('RequestedforHead').errors.required">
                                                    Requested for is required.
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label>Assignment
                                                Group</label></div>
                                        <div class="col-md-8">
                                            <p-dropdown [options]="assingmentGroupList" placeholder="--Select--"
                                                filter="true" [showClear]="true" formControlName="AssignmentGroupID"
                                                (onChange)="ChangeAssigmentGroup($event,1)">
                                            </p-dropdown>
                                            <mat-error
                                                *ngIf="GetFormControls('AssignmentGroupID').invalid && (GetFormControls('AssignmentGroupID').dirty || GetFormControls('AssignmentGroupID').touched)"
                                                class="ValidationError">
                                                <mat-error *ngIf="GetFormControls('AssignmentGroupID').errors.required">
                                                    Item is required.
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel">
                                            <label class="control-label">
                                                Requested for phone
                                            </label>
                                        </div>
                                        <div class="col-md-8"> <input class="form-control"
                                                formControlName="RequestedForCUG" readonly="true"></div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label>Assigned
                                                To</label></div>
                                        <div class="col-md-8">
                                            <p-autoComplete formControlName="AssignedEmp" [suggestions]="assignedToList"
                                                (completeMethod)="SearchActiveEmployee($event)" field="EmployeeName"
                                                [forceSelection]="true" [minLength]="3" size="35"
                                                (onSelect)="SetEmployeeDetails($event)"
                                                (onClear)="clearAutoComplete('AssignedEmp')">
                                            </p-autoComplete>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-4 control-label paddingforRightlabel"> <label
                                                class="control-label">Location</label></div>
                                        <div class="col-md-8">
                                            <p-dropdown [options]="locationList" [readonly]="true"
                                                placeholder="--Select--" formControlName="ReqLocation" filter="true">
                                            </p-dropdown>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">

                                        <!-- <button class="btn-primary1" style="width: 40px;font-size: 8px; height: 10px;" type="button" mat-stroked-button 
                        (click)="OpenSPOC(SPOCPopUP)">
                        SPOC List
                    </button> -->
                    <a class="spoc-link" (click)="OpenSPOC(SPOCPopUP)">
                        SPOC List (Tap To Open)
                    </a>
                    

                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-12 control-label paddingforRightlabel"> <label
                                                class="control-label">Short Description</label></div>

                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="row">
                                        <div class="col-md-12"> <input class="form-control"
                                                formControlName="ShortDescription" [readonly]="true"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="row">
                                        <div class="col-md-12 control-label paddingforRightlabel"> <label
                                                class="control-label">Description</label></div>

                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <textarea class="form-control" formControlName="LongDescription"
                                                [readonly]="true"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="row">
                                        <div class="col-md-12 control-label paddingforRightlabel"> <label
                                                class="control-label">Add new comment</label></div>

                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <textarea class="form-control"
                                                formControlName="AdditionalComment"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </form>

                    <form [formGroup]="ServiceRequestLogDetail" (ngSubmit)="SubmitSRLog()">
                        <fieldset style="width: 101%;">
                            <legend>Notes</legend>

                            <!-- anmol -->
                            <!-- <div style="margin-top: -10px; font-size: 12px; font-weight: bold;">
                                Created On: <span style="font-weight: normal;">{{ this.ServiceRequestForm.controls.CreatedOn.value | date:'dd/MMM/yyyy' }}</span>
                            </div> -->
                            

                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-md-2"><label class="control-label paddingforRightlabel">Work
                                            notes</label></div>
                                    <div class="col-md-10">
                                        <textarea class="form-control" placeholder="Work notes"
                                            style="border: 1px solid rgba(0,0,0,.125);height: 43px !important;margin-left: -5px;"
                                            matInput formControlName="LogText" matTextareaAutosize></textarea>

                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-10" style="text-align: right;margin-bottom: 23px;">
                                        <button type="submit" class="btn-primary1">
                                            Post
                                        </button>
                                    </div>
                                </div>
                                
                                <div class="row" style="margin-top: -25px;"
                                    *ngFor='let item of ServiceRequestLogDetailList'>
                                    <div class="col-md-12">
                                        <ul class="h-card-wrapper activities-form">
                                            <li class="h-card h-card_md h-card_comments"
                                                style="margin-left: 130px;width: 85%;"
                                                *ngIf="item.Type=='Field changes'">
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                                                    <span
                                                        class="sn-card-component-createdby">{{item.CreatedByName}}</span>
                                                </div>
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta">
                                                    <span class="sn-card-component-time">
                                                        <span> {{item.Type}}</span>
                                                        <span class="sn-card-component_accent-bar_bullet">•</span>
                                                        <div class="date-calendar">{{item.CreatedOn}}</div>
                                                    </span>
                                                </div>
                                                <div class="sn-card-component sn-card-component_records">
                                                    <div class="sn-widget">
                                                        <ul class="sn-widget-list sn-widget-list-table">
                                                            <li>
                                                                <span
                                                                    class="sn-widget-list-table-cell">{{item.FieldName}}</span><span
                                                                    class="sn-widget-list-table-cell">
                                                                <!-- <span > {{item.LogText}} </span>   -->
                                                                <span class="sn-widget-textblock-body sn-widget-textblock-body_formatted" [innerHTML]="item.LogText | linkify"></span>
                                                                
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="h-card h-card_md h-card_comments"
                                                style="margin-left: 130px;width: 85%;" *ngIf="item.Type=='Email Sent'">
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                                                    <span class="sn-card-component-createdby">system</span>
                                                </div>
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta">
                                                    <span class="sn-card-component-time">
                                                        <span>Email sent</span><span
                                                            class="sn-card-component_accent-bar_bullet">•</span>
                                                        <div class="date-calendar">{{item.CreatedOn}}</div>
                                                    </span>
                                                </div>
                                                <div class="sn-card-component sn-card-component_records">
                                                    <div class="sn-widget">
                                                        <ul class="sn-widget-list sn-widget-list-table">
                                                            <li>
                                                                <span class="sn-widget-list-table-cell"><span
                                                                        class="icon-mail"></span></span><span
                                                                    class="sn-widget-list-table-cell">Email sent</span>
                                                            </li>
                                                            <li>
                                                                <span
                                                                    class="sn-widget-list-table-cell">Subject:</span><span
                                                                    class="sn-widget-list-table-cell">{{item.MailSubject}}</span>
                                                            </li>
                                                            <li>
                                                                <span
                                                                    class="sn-widget-list-table-cell">From:</span><span
                                                                    class="sn-widget-list-table-cell">EY Talent
                                                                    Connect</span>
                                                            </li>
                                                            <li>
                                                                <span class="sn-widget-list-table-cell">To:</span><span
                                                                    class="sn-widget-list-table-cell">{{item.MailTo}}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="sn-card-component sn-card-component_summary sn-card-component_summary_spacing"
                                                    id="activity_84261326dbd23c9429efaa484b961969"
                                                    [innerHTML]="item.LogText">
                                                    <div class="sn-widget sn-widget-textblock"></div>
                                                </div>
                                            </li>
                                            <li class="h-card h-card_md h-card_comments"
                                                style="margin-left: 130px;width: 85%;" *ngIf="item.Type=='Work notes'">
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                                                    <span
                                                        class="sn-card-component-createdby">{{item.CreatedByName}}</span>
                                                </div>
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta">
                                                    <span class="sn-card-component-time">
                                                        <span>{{item.Type}}</span><span
                                                            class="sn-card-component_accent-bar_bullet">•</span>
                                                        <div class="date-calendar">{{item.CreatedOn}}</div>
                                                    </span>
                                                </div>
                                                <div class="sn-card-component sn-card-component_summary sn-card-component_summary_spacing"
                                                    id="activity_6fa7cb6edb52fc5c088caa484b961983">
                                                    <div class="sn-widget sn-widget-textblock state-expanded">
                                                        <span class="sn-widget-textblock-body sn-widget-textblock-body_formatted" [innerHTML]="item.LogText | linkify"></span>

                                                    </div>
                                                </div>

                                                <!-- anmol -->
                            <!-- <div style="margin-top: -10px; font-size: 12px; font-weight: bold;margin-left: 480px;">
                                Created On: <span style="font-weight: normal;">{{ this.ServiceRequestForm.controls.CreatedOn.value | date:'dd/MMM/yyyy' }}</span>
                            </div> -->

                                            </li>
                                            <li class="h-card h-card_md h-card_comments"
                                                style="margin-left: 130px;width: 85%;" *ngIf="item.Type=='Attachment'">
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                                                    <span
                                                        class="sn-card-component-createdby">{{item.CreatedByName}}</span>
                                                </div>
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta">
                                                    <span class="sn-card-component-time">
                                                        <span>{{item.Type}}</span><span
                                                            class="sn-card-component_accent-bar_bullet">•</span>
                                                        <div class="date-calendar">{{item.CreatedOn}}</div>
                                                    </span>
                                                </div>
                                                <div class="sn-card-component sn-card-component_summary sn-card-component_summary_spacing"
                                                    id="activity_6fa7cb6edb52fc5c088caa484b961983">
                                                    <div class="sn-widget sn-widget-textblock state-expanded">
                                                        <span
                                                            class="sn-widget-textblock-body sn-widget-textblock-body_formatted">
                                                            Attachment: 
                                                            <span *ngIf="item.BlobId != null">
                                                                <a style="cursor:pointer"
                                                                    (click)="GetAttachmentDetailByID(item)">{{item.AttachmentName}}</a>
                                                            </span>
                                                            {{item.LogText}}
                                                        </span>
                                                    
                                                    </div>
                                                </div>
                                                <!-- anmol
                            <div style="margin-top: -10px; font-size: 12px; font-weight: bold;margin-left: 480px;">
                                Created On: <span style="font-weight: normal;">{{ this.ServiceRequestForm.controls.CreatedOn.value | date:'dd/MMM/yyyy' }}</span>
                            </div> -->
                                            </li>
                                            <li class="h-card h-card_md h-card_comments"
                                                style="margin-left: 130px;width: 85%;" *ngIf="item.Type=='Delete'">
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta sn-card-component_meta_sibling">
                                                    <span
                                                        class="sn-card-component-createdby">{{item.CreatedByName}}</span>
                                                </div>
                                                <div
                                                    class="sn-card-component sn-card-component_first sn-card-component_meta">
                                                    <span class="sn-card-component-time">
                                                        <span>{{item.Type}}</span><span
                                                            class="sn-card-component_accent-bar_bullet">•</span>
                                                        <div class="date-calendar">{{item.CreatedOn}}</div>
                                                    </span>
                                                </div>
                                                <div class="sn-card-component sn-card-component_summary sn-card-component_summary_spacing"
                                                    id="activity_6fa7cb6edb52fc5c088caa484b961983">
                                                    <div class="sn-widget sn-widget-textblock state-expanded">
                                                        <span
                                                            class="sn-widget-textblock-body sn-widget-textblock-body_formatted">{{item.LogText}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <!-- anmol -->
                            <!-- <div style="margin-top: -10px; font-size: 12px; font-weight: bold;">
                                Created On: <span style="font-weight: normal;">{{ this.ServiceRequestForm.controls.CreatedOn.value | date:'dd/MMM/yyyy' }}</span>
                            </div> -->

                                <!-- <table style="width: 100%;">
                                        <tr>
                                          <td style="width: 10%;">
                                            <label class="control-label">Work notes</label>
                                          </td>
                                          <td style="width: 90%;">
                                            <textarea  class="form-control" matInput formControlName="LogText"
                                            matTextareaAutosize ></textarea>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width: 10%;">

                                          </td>
                                          <td style="width: 90%;text-align:right">
                                            <button  type="submit" mat-stroked-button
                                            >Post</button>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width: 10%;">
                                            <label class="control-label">Activities:</label>
                                          </td>
                                          <td style="width: 90%;">
                                           <div style="border: 1px solid black;">
                                            <table style="width: 100%;">
                                              <tr *ngFor='let item of ServiceRequestLogDetailList' >
                                                <td style="width: 30%;">
                                                {{item.CreatedByName}}
                                                </td>
                                                <td style="width: 50%;">
                                                  {{item.LogText}}
                                                  </td>
                                                <td style="text-align: right;width: 20%;">
                                                  {{item.Type}} {{item.CreatedOn}}
                                                </td>
                                              </tr>

                                            </table>

                                           </div>
                                          </td>
                                        </tr>
                                      </table> -->
                            </div>
                        </fieldset>

                    </form>

                    <ng-template #SPOCPopUP>

                        <header class="panel-heading" style="margin: 5px;">
                            <h5 class="panel-title">SPOC List</h5>
                        </header>
                        <div class="row" style="margin: 5px;">
                            <div class="col-md-12">
                                <div class="col-md-4 control-label paddingforRightlabel"> <label>Assignment
                                        Group</label></div>
                                <p-dropdown  class="custom-dropdown" [options]="GroupListForSPOC"
                                (onChange)="GetSPOCName('Group',$event)"
                                    placeholder="--Select--" [(ngModel)]="SelectedGroup" filter="true"
                                    [showClear]="true"></p-dropdown>
                                <div class="col-md-4 control-label paddingforRightlabel"> <label> Location</label></div>
                                <p-dropdown class="custom-dropdown" [options]="LocationListForSPOC"
                                (onChange)="GetSPOCName('Location',$event)"
                                    placeholder="--Select--" [(ngModel)]="SelectedLocation" filter="true"
                                    [showClear]="true"></p-dropdown>
                                    <br>
                                    <br>
                                <textarea readonly [(ngModel)]="SPOCName" class="form-control" placeholder="SPOC Name"
                                    style="border: 1px solid rgba(0,0,0,.125);height: 20px !important;margin-left: -5px;"
                                    matInput></textarea>
                            </div>
                        </div>
                        <br>
                        <footer class="panel-footer" style="margin: 5px;">

                            <button class="btn-primary1" mat-stroked-button type="button" (click)="Exit()">Exit</button>
                        </footer>
                    </ng-template>

                </div>
            </div>
        </div>
    </div>
</div>